export default "__VITE_ASSET__10f8c81b__"